import dayjs from 'dayjs'
import { isDate } from 'lodash-es'

import { DATE_TIME_FORMAT } from './const'
import { isString } from '@/utils/isString'

export const formatDateTime = (
  time: unknown,
  dateFormat: string = DATE_TIME_FORMAT,
) => {
  if (isDate(time) || isString(time)) {
    return dayjs(time).format(dateFormat)
  }

  return ''
}

export { DATE_TIME_FORMAT } from './const'
export { DATE_FORMAT } from './const'
export { TIME_FORMAT } from './const'
